import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import * as associationsApi from '../data/api/associationsApi';
import * as authApi from '../data/api/authApi';
import * as avatarsApi from '../data/api/avatarsApi';
import * as callObjectApi from '../data/api/callObjectApi';
import * as commentsApi from '../data/api/commentsApi';
import * as crmV3Api from '../data/api/crmV3Api';
import * as dealsApi from '../data/api/dealsApi';
import * as googleApi from '../data/api/googleApi';
import * as participantsApi from '../data/api/participantsApi';
import * as playbooksApi from '../data/api/playbooksApi';
import * as propertiesApi from '../data/api/propertiesApi';
import * as snippetsApi from '../data/api/snippetsApi';
import * as userApi from '../data/api/userApi';
import rootReducer from '../slices';
import errorThunkMiddleware from './errorThunkMiddleware';
const apiExtraArgument = {
  associationsApi,
  avatarsApi,
  authApi,
  userApi,
  callObjectApi,
  googleApi,
  snippetsApi,
  playbooksApi,
  crmV3Api,
  dealsApi,
  propertiesApi,
  commentsApi,
  participantsApi
};
const middleware = [thunk.withExtraArgument(apiExtraArgument), errorThunkMiddleware];
export const store = configureStore({
  reducer: rootReducer,
  middleware,
  preloadedState: {}
});